import {Sky, Float, Text, ScrollControls, useGLTF } from "@react-three/drei"

import Scene from './Components/Scene.jsx'
import Ocean from "./Components/Outdoor/Ocean.jsx"
import CameraScroll from './Components/CameraScroll.jsx'

import "./App.css";
import ScrollHelper from "./Components/ScrollHelper.jsx";

export default function App() {

  const { nodes } = useGLTF('./Model/House.glb')
  
  return (
    <>
      {/* Sky for background */}
      <Sky 
        sunPosition={[100, 20, 100]}
        inclination={0.6}
        azimuth={0.25}
      />
      
      {/* Modern luxury lighting with warm tones - increased brightness */}
      <ambientLight intensity={ 1.2 } color="#ffffff"/>
      <directionalLight 
        position={ [10, 15, 10] } 
        intensity={ 2.0 } 
        color="#fff5e6"
        castShadow
      />
      <directionalLight 
        position={ [-10, 10, -10] } 
        intensity={ 1.2 }
        color="#ffd9a6"
      />
      <directionalLight 
        position={ [0, 10, 15] } 
        intensity={ 1.5 }
        color="#ffffff"
      />
      <pointLight 
        position={ [0, 12, 0] } 
        intensity={ 0.8 } 
        color="#d4af37"
        distance={50}
      />
      <spotLight
        position={[0, 20, 0]}
        angle={0.5}
        penumbra={1}
        intensity={0.6}
        color="#d4af37"
        castShadow
      />

      <Ocean/>
      
      {/* Lighter fog for better visibility */}
      <fog attach="fog" args={['#87CEEB', 50, 150]} />
      
      <Float rotationIntensity={0.9}>
          <Text
            font="./fonts/font.ttf"
            position-y={ 15 }
            rotation-y={ 0.48 * Math.PI }
            curveRadius={ -50 }
            fontSize={ 5 }
            color="#ffffff"
          >
            Disha's Portfolio
        </Text>
      </Float>

      <Scene nodes= { nodes }/>
     
          
      <ScrollControls pages={25} damping={0.2}>    
        <CameraScroll nodes= { nodes }/>
      </ScrollControls>

      <ScrollHelper/>
      
    </>
  )
}

useGLTF.preload('./Model/House.glb')
